module.exports = __webpack_public_path__ + "media/images/goals-4-57ca7ad9169f6bb76a708910b6180f17.jpg";